import { render } from "lit-html";
import { caseInsensitiveEquals } from "../../../utils/number.js";
import { IProductWithVariants, IVariant, VariantSelectorBase } from "./variant-selector-base.js";

const $ = window.jQuery;

export abstract class DropDownVariantSelectorBase extends VariantSelectorBase {
    private $dropDown: any;

    constructor(name: string, private version: number, selectorContainerElement: HTMLElement, product: IProductWithVariants, variantTypeId: number, translations: Map<string, string>, showPricesInclVat: boolean, loadAdditionalInfo: boolean) {
        super(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
    }

    protected processAfterRender() {
        super.processAfterRender();

        this.$dropDown = $(this.selectorContainerElement).find('select');

        const self = this;
        this.$dropDown.on('change', function (evt: any) {
            var newVariantValue = parseInt(evt.target.value) || 0;
            self._triggerSelectorChangedEvent(newVariantValue);
        });
    }

    public setSelected(variantId: string): void {
        var newVariantValue = parseInt(variantId) || 0;
        var currentVariantValue = this.getSelected();
        var isVariantAlreadySelected = newVariantValue === currentVariantValue;

        if (!isVariantAlreadySelected) {
            this.$dropDown.val(newVariantValue);

            this._triggerSelectorChangedEvent(newVariantValue);
        }
    }

    public setSelectedByName(variantValueName: string): void {
        if (variantValueName) {
            const foundVariantValue = this.variantType.variants.find(function (currentVariant: IVariant) {
                return caseInsensitiveEquals(currentVariant.name, variantValueName);
            });

            if (foundVariantValue) {
                this.setSelected(foundVariantValue.id.toString());
            }
        }
    }

    public getSelected(): number {
        return parseInt(this.$dropDown.val() || 0);
    }

    public filterVariants(unavailableVariants: any, preselectSingleAvailable: any): void {
        const self = this;
        var $singleAvailableOption;

        var $options = this.$dropDown.find('option');
        $options.each(function () {
            var $option = $(this);
            var variantId = $option.val();
            if (variantId <= 0) {
                return; // Default option
            }

            var cleanOptionName = $option.data('cleanname');
            if (typeof (cleanOptionName) === 'undefined') {
                cleanOptionName = $option.text();

                $option.data('cleanname', cleanOptionName);
            }

            const unavailableVariant = unavailableVariants[variantId];
            if (self.product.showUnavailableVariants && self.product.showOutOfStockVariants) {
                if (unavailableVariant) {
                    $option.text(cleanOptionName + (unavailableVariant.message ? ' (' + unavailableVariant.message + ')': ''));
                    $option.addClass('disabled');

                    if (unavailableVariant.disabled) {
                        $option.attr('disabled', 'disabled');
                    }
                } else {
                    $option.text(cleanOptionName);

                    $option.removeClass('disabled');
                    $option.removeAttr('disabled');

                    $singleAvailableOption = typeof ($singleAvailableOption) === 'undefined' ? $option : null;
                }
            }
            else {
                if (unavailableVariant) {
                    $option.attr('disabled', 'disabled');
                    $option.hide();
                } else {
                    $option.removeAttr('disabled');
                    $option.show();
                }
            }
        });

        if ($singleAvailableOption && preselectSingleAvailable) {
            this.setSelected($singleAvailableOption.val());

            if ($options.length === 2 && this.$dropDown.is(':visible')) {
                this.$dropDown.parent().prepend('<span class="c-variant-selector__single-available">' + $singleAvailableOption.text() + '</span>');
                this.$dropDown.css('display', 'none');
            }
        }
    }

    public processVariants(variantTypeToProductInfoMap: any): void {
        var $options = this.$dropDown.find('option');
        $options.each(function () {
            var $option = $(this);
            var variantId = $option.val();
            if (variantId <= 0) {
                return; // Default option
            }

            var productInfo = variantTypeToProductInfoMap[variantId];
            if (productInfo && productInfo.discountInfo.isOutlet) {
                var replaceEmptyString = productInfo.discountInfo.flagName.replace(/\s+/g, "-").toLowerCase();
                $option.addClass(replaceEmptyString + ' flag-' + productInfo.discountInfo.flagId + '-' + replaceEmptyString);
            }
        });
    }

    private _isSelectedAvailable() {
        var $selected = this.$dropDown.find('option:selected');

        // Default option (or unselected state) should be marked as available. Otherwise, unavailable variants filtering will not happen on deselection.
        return $selected.length === 0 || $selected.is(':not(.disabled)');
    }

    private _setVariantSelectorLabelPrefix(prefix) {
        if (this.version == 2) {
            var $variantSelectorLabel = this.$dropDown.find('.js-select-variant-label');
            $variantSelectorLabel.text(`${prefix} ${this.variantSelectorData.variantTypeName}...`);
        } else {
            var $variantSelectorLabel = $(this.selectorContainerElement).find('.js-select-variant-label');
            $variantSelectorLabel.text(`${prefix} ${this.variantSelectorData.variantTypeName}`);
        }
    }

    private _triggerSelectorChangedEvent(newVariantValue: any) {
        var isSelectedOptionAvailable = this._isSelectedAvailable();
        $(this.selectorContainerElement).trigger(this.VARIANT_CHANGED_EVENT, [this.variantType, newVariantValue, isSelectedOptionAvailable, this.product.productId]);

        this._setVariantSelectorLabelPrefix(this.getSelected() > 0
            ? this.variantSelectorData.labels.changeSelection
            : this.variantSelectorData.labels.select);
    }
}
